<template>
    <div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/shortUrl/save')" type="primary" icon="el-icon-plus" size="small" @click="$refs.editTpl.show()">生成链接</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="path" label="页面路径">
                </el-table-column>
                <el-table-column label="小程序URL" prop="urlLink">
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">                        
                        <el-button
                            type="text"
                            size="small"
                            @click="copy(scope.row)"
                            >复制短链接</el-button
                        >
						<el-button
						    v-if="$utils.have('/shortUrl/save')"
						    type="text"
						    size="small"
						    @click="$refs.UrldataTpl.show(scope.row)"
						    >查看数据</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <input class="copyTool" ref="copyTool" :value="copyValue" />
        <edit ref="editTpl" @onUpdate="getDataList()"></edit>
		<Urldata ref="UrldataTpl" @onUpdate="getDataList()"></Urldata>
    </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import Urldata from "./components/urldata.vue";
const defaultParams = {
    pageNo:1
}
export default {
    components:{
        Edit,
		Urldata
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
            copyValue:'',
            copyTimer:null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/applet/link/pageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //复制链接
        copy(obj){
            this.copyValue = `${obj.urlLink}`;
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
    }
}
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
}
</style>